import { Getter, Setter } from "../services/ComService"
import GroupDTO, { IGroup } from "./GroupDTO"

export default class GroupsDTO {
  private items: GroupDTO[] = []

  public async getFromServer() {
    const data = await Getter('admin/groups/')
    if (!data) {
      console.log('GroupsDTO could not load data')
      return
    }
    // console.log(data)
    this.items = data.map((d: IGroup) => new GroupDTO(d))
  }

  public getItems() {
    return this.items
  }

  public async addItem(name: string) {
    await Getter(`admin/group/add/${name}`)
    await this.getFromServer()
  }

  public deleteItem() {

  }

  public renameItem() {

  }
}
